import * as React from "react";
import SessionPanel from "components/shared/SessionPanel";
import { LoginVerificationType } from "models/Constants";
import { Button } from "reactstrap";

const LoginVerificationOptions: React.FC<{
  email: string;
  phone?: string;
  onVerificationTypeSelected: (selectedType: LoginVerificationType) => void;
  onGoBack?: () => void;
}> = ({ email, phone, onVerificationTypeSelected, onGoBack }) => {
  return (
    <SessionPanel
      title="How would you like to receive your one time password?"
      onGoBack={onGoBack}
    >
      {email && (
        <Button
          color="primary"
          className="w-100"
          onClick={() =>
            onVerificationTypeSelected(LoginVerificationType.Email)
          }
        >
          <div style={{ fontSize: "0.75rem" }}>Send code via email</div>
          <div className="text-truncate">{email}</div>
        </Button>
      )}

      {phone && (
        <Button
          color="primary"
          className="w-100 mt-3"
          onClick={() => onVerificationTypeSelected(LoginVerificationType.SMS)}
        >
          <div style={{ fontSize: "0.75rem" }}>Send code via SMS</div>
          <div>{phone}</div>
        </Button>
      )}
    </SessionPanel>
  );
};

export default LoginVerificationOptions;
